import axios, { AxiosResponse } from "axios";
import { differenceInSeconds } from "date-fns";
import { AuthenticationResultEnum } from "../../../common/enums/AuthenticationResultEnum";
import { eLynxObjectTypeEnum } from "../../../common/enums/eLynxObjectType";
import { IAuthenticationMessage } from "../../../common/models/AuthenticationMessage";
import { IAuthenticationResult } from "../../../common/models/AuthenticationResult";
import { IeLynxUser } from "../../../common/models/eLynxUser";
import { RestError } from "../../rest-service/RestService";
import storageService from "../../storage/storage-service/StorageService";
import { StorageKeys } from "../../storage/StorageKeys";

class ELynxAuthService {

    private _authenticationMessage: IAuthenticationMessage | null = null;
    private _accessToken: string | null = null;
    private _refreshToken: string | null = null;
    private _customerID = 0;
    private _customerTypeID = 0;
    private _loginName: string | null = null;
    private _loginAutomatically = false;   //@@kg review scadalynx code, I don't see where this is set in that code

    constructor() {
        this._init();
    }

    private async _callTokenEndpoint(grantType: string, formData: string[]): Promise<AxiosResponse<IAuthenticationMessage>> {


        const response = await axios.post<string, AxiosResponse<IAuthenticationMessage>>("token",
            `grant_type=${grantType}&${formData.join("&")}`,
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                responseType: "json"
            });

        if (response.status === 200) {
            return response;
        } else {
            //throw Error("todo");
            const restError: RestError = {
                code: response.status.toString(),
                name: response.statusText,
                message: response.statusText,
                config: response.config,
                request: response.request,
                isAxiosError: true,
                toJSON: () => {return {};}
            }

            throw restError;
        }


        // // set up the post to the token endpoint
        // const header = { "Content-Type": "application/x-www-form-urlencoded" };
        // const client: rest.Client = rest.wrap<restPathPrefix.Config>(restPathPrefix, { prefix: this.baseUrl });
        // const path = ["token"].join("/");
        // const entity = "grant_type=" + grantType + "&" + formData.join("&");

        // const promise: rest.ResponsePromise =
        //     client({
        //         method: "POST",
        //         path: path,
        //         headers: header,
        //         entity: entity
        //     });

        // const response: rest.Response = await promise;

        // if (response.status.code !== 200) {
        //     return new RestResponse<AuthenticationErrorResponse>(
        //         new RestStatus(response.status.code, response.status.text),
        //         new AuthenticationErrorResponse(response.entity));
        // } else {
        //     return new RestResponse<AuthenticationMessage>(
        //         new RestStatus(response.status.code, response.status.text),
        //         new AuthenticationMessage(response.entity));
        // }
    }

    //const _processAuthenticationResponse(response: IRestResponse<AuthenticationMessage | AuthenticationErrorResponse>) {
    private _processAuthenticationResponse(response: AxiosResponse<IAuthenticationMessage>): IAuthenticationResult {
        if (response.status !== 200) {

            // // if an error occurs in the actual rest call, the entity contains the error information from the rest call.
            // const err: AuthenticationErrorResponse = <AuthenticationErrorResponse>(response.entity);

            // this._loggerService.logger("login")
            //     .error({
            //         showDetail: true,
            //         message: err.error_description || err.error,
            //         errorCode: err.error
            //     });

            //throw new Error(AuthenticationResultEnum[response.data.error]);
            const restError: RestError = {
                code: response.status.toString(),
                name: response.statusText,
                message: response.statusText,
                config: response.config,
                request: response.request,
                isAxiosError: true,
                toJSON: () => {return {};}
            }

            throw restError;
            //throw new Error("todo");
        }

        if (!response.data.customerID) {
            // Clean up existing authentication data if a customer id was provided because we're about to login fresh. Note that
            // we have to do this before storing the message in this._authenticationMessage, otherwise calling logout will clobber
            // it.
            this.logout();
        }

        this._authenticationMessage = response.data;

        //console.log(`SCADALynx auth ${JSON.stringify(this._authenticationMessage)}`);

        // store the authentication message
        const user: IeLynxUser | undefined = this._getUserModel(this._authenticationMessage);

        if (this._authenticationMessage.customerID) {

            // store the refresh token.  We do not want to use the new refresh token returned after refreshing
            // the access token; otherwise, it will never expire.
            this._accessToken = this._authenticationMessage.access_token;
            this._refreshToken = this._authenticationMessage.refresh_token;
            this._customerID = this._authenticationMessage.customerID;
            this._customerTypeID = this._authenticationMessage.customerTypeID;
            this._loginName = this._authenticationMessage.userLogin;

            const key: string = this._getTokenStorageKey(this._loginName, this._customerID);
            if (this._loginAutomatically) {
                storageService.local.set(key, this._authenticationMessage);
            } else {
                storageService.session.set(key, this._authenticationMessage);
            }

            // start a task to refresh the access token before it expires.
            //this._startRefreshTask();

            // return new RestResponse<AuthenticationResult>(
            //     new RestStatus(response.status.code, response.status.text),
            //     new AuthenticationResult(this._customerID, user, this._authenticationMessage.customers));
        }
        //  else {

        //     return new RestResponse<AuthenticationResult>(
        //         new RestStatus(response.status.code, response.status.text),
        //         new AuthenticationResult(null, user, this._authenticationMessage.customers));
        // }

        return {
            customerID: this._customerID,
            customerTypeID: this._customerTypeID,
            user: user,
            customers: this._authenticationMessage.customers && this._authenticationMessage.customers.length > 0 ?
                JSON.parse(this._authenticationMessage.customers) : null,
            mfaToken: this._authenticationMessage.mfaToken,
            mfaExpiry: this._authenticationMessage.mfaExpiry
        };
    }

    private _getTokenStorageKey = (loginName: string, customerID: number) =>
                    `${loginName ? loginName.toLowerCase() : loginName}:${customerID}`;

    private async _refreshAccessToken(refreshToken: string): Promise<string> {

        try {
            const response = await this._callTokenEndpoint("refresh_token", ["refresh_token=" + refreshToken]);

            // if not status = 200 then redirect to the login page
            if (response && response.status !== 200) {
                //const err: AuthenticationErrorResponse = <AuthenticationErrorResponse>data.entity;

                this.logout();

                // const msg: any = err.error_description || err.error;
                // const apiError: IeLynxAPIError = {
                //     errorCode: AuthenticationResultEnum[AuthenticationResultEnum.TokenExpired],
                //     exceptionMessage: "",
                //     exceptionType: "",
                //     logReference: "",
                //     message: msg,
                //     showDetail: true
                // };


                // config: AxiosRequestConfig;
                // code?: string;
                // request?: any;
                // response?: AxiosResponse<T>;
                // isAxiosError: boolean;
                // toJSON: () => object;

                const restError: RestError = {
                    code: AuthenticationResultEnum[AuthenticationResultEnum.TokenExpired],
                    name: AuthenticationResultEnum[AuthenticationResultEnum.TokenExpired],
                    message: AuthenticationResultEnum[AuthenticationResultEnum.TokenExpired],
                    config: response.config,
                    request: response.request,
                    isAxiosError: true,
                    toJSON: () => {return {};}
                }

                // // use this logger so the code does not try to call user activity log api.
                // this._loggerService.logger("login").error(apiError);
                // throw new Error(err.error_description);

                throw restError;
            } else {

                // store the refreshed authentication message
                //_authenticationMessage = <AuthenticationMessage>data.entity;
                this._authenticationMessage = response?.data as IAuthenticationMessage;

                this._accessToken = this._authenticationMessage.access_token;

                if (this._loginName) {
                    const key: string = this._getTokenStorageKey(this._loginName, this._customerID);
                    if (this._loginAutomatically) {
                        storageService.local.set(key, this._authenticationMessage);
                    } else {
                        storageService.session.set(key, this._authenticationMessage);
                    }
                }

                return this._authenticationMessage.access_token;
            }

        } catch(reason) {

            this.logout();

            const err = reason as RestError;
            if (err.response) {
                err.response.data.errorCode = AuthenticationResultEnum[AuthenticationResultEnum.TokenExpired];
            }

            //const msg: any = err.error_description || err.error;
            // const apiError: RestError<IeLynxAPIError> = {
            //     errorCode: AuthenticationResultEnum[AuthenticationResultEnum.TokenExpired],
            //     exceptionMessage: "",
            //     exceptionType: "",
            //     logReference: "",
            //     message: msg,
            //     showDetail: true
            // };

            // const apiError: RestError = {
            //     errorCode: AuthenticationResultEnum[AuthenticationResultEnum.TokenExpired],
            //     exceptionMessage: "",
            //     exceptionType: "",
            //     logReference: "",
            //     message: msg,
            //     showDetail: true
            // };


            // this._loggerService.logger().error(apiError);


            //throw new Error(err.error_description);
            throw err;
        }
    }

    private _getUserModel(authMessage: IAuthenticationMessage): IeLynxUser | undefined {

        if (!authMessage.userID) {

            return undefined;
        }

        const user: IeLynxUser = {

            displayText: authMessage.userName,
            loginName: authMessage.userLogin,
            globalLoginID: +authMessage.globalLoginID,
            id: +authMessage.userID,
            objectType: eLynxObjectTypeEnum.User,
            baseGroup: {
                id: +authMessage.baseGroupID,
                organizationID: +authMessage.baseOrganizationID,
                objectType: eLynxObjectTypeEnum.Group
            },
            startGroup: {
                id: +authMessage.startGroupID,
                organizationID: +authMessage.baseOrganizationID,
                objectType: eLynxObjectTypeEnum.Group
            },
            homeUrl: authMessage.homeURL,
            jobTitle: authMessage.jobTitle,
            companyName: authMessage.companyName,
            timeZoneIndex: +authMessage.timeZoneID,
            isElynxAdmin: authMessage.isElynxAdmin === "true",
            jobFunction: authMessage.jobFunction,
            phoneNumber: authMessage.phoneNumber,
            passwordRequiredLength: +authMessage.passwordRequiredLength,
            externalSignInName: authMessage.externalSignInName,
            userGuid: authMessage.userGuid,
            mobileAccessEnabled: authMessage.mobileAccessEnabled === "true"
        };

        return user;
    }

    private _init(): void {

        const customerID: number = storageService.session.get(StorageKeys.LastCustomerID, 0) ||
                            storageService.local.get(StorageKeys.LastCustomerID, 0);
        const loginName: string = storageService.session.get(StorageKeys.LastUserName, '') ||
                            storageService.local.get(StorageKeys.LastUserName, '');

        //console.log(`ELynxAuthService initializing!! customerID=${customerID} loginName=${loginName}`);
        

        if (customerID && loginName && loginName.length > 1) {

            const key: string = this._getTokenStorageKey(loginName, customerID);

            //then try to get the authentication message from session or local storage
            this._authenticationMessage = storageService.session.get<IAuthenticationMessage | null>(key, null) ||
                                        storageService.local.get<IAuthenticationMessage | null>(key, null);

            if (this._authenticationMessage) {

                // store the refresh token.  We do not want to use the new refresh token returned after refreshing
                // the access token; otherwise, it will never expire.
                this._accessToken = this._authenticationMessage.access_token;
                this._refreshToken = this._authenticationMessage.refresh_token;
                this._customerID = customerID;
                this._loginName = this._authenticationMessage.userLogin;

                //@@kg todo this._startRefreshTask();
            }
        }
    }

    public setLoginAutomatically(value: boolean) {
        this._loginAutomatically = value;
    }

    public async authenticate(customerID: number | null,
        userName: string,
        pwHash: string,
        screenHeight?: number,
        screenWidth?: number,
        isMobile?: boolean,
        loginAutomatically?: boolean,
        otp?: string,
        mfaSource?: number,
        mfaToken?: string,
        impersonatingGlobalLoginID?: number): Promise<IAuthenticationResult> {

        this._loginAutomatically = (typeof (loginAutomatically) === "boolean") ? loginAutomatically : false;
        const otpData = otp !== undefined && otp !== null
            ? [
                "otp=" + otp,
                "mfaSource=" + mfaSource
            ]
            : [];
        const tokenData = mfaToken !== undefined && mfaToken !== null
            ? ["mfaToken=" + mfaToken]
            : [];
        const data = await this._callTokenEndpoint(
            "password",
            [
                "customerid=" + customerID,
                "username=" + userName,
                "password=" + pwHash,
                "screenHeight=" + screenHeight,
                "screenWidth=" + screenWidth,
                "isMobile=" + isMobile,
                "impersonatingGlobalLoginID=" + impersonatingGlobalLoginID,
                ...otpData,
                ...tokenData
            ]);

        return this._processAuthenticationResponse(data as AxiosResponse<IAuthenticationMessage>);
    }

    public async reauthenticate(username: string, pwhash: string): Promise<IeLynxUser | undefined> {

        const response = await this._callTokenEndpoint(
            "password",
            [
                "customerid=" + this._customerID,
                "username=" + username,
                "password=" + pwhash
            ]);


        if (response.status !== 200) {
            //const err: AuthenticationErrorResponse = <AuthenticationErrorResponse>data.entity;
            //throw new Error(AuthenticationResultEnum[err.error]);
            const restError: RestError = {
                code: AuthenticationResultEnum[AuthenticationResultEnum.LoginFailed],
                name: AuthenticationResultEnum[AuthenticationResultEnum.LoginFailed],
                message: AuthenticationResultEnum[AuthenticationResultEnum.LoginFailed],
                config: response.config,
                request: response.request,
                isAxiosError: true,
                toJSON: () => {return {};}
            }

            throw restError;

        } else {
            // store the authentication message
            this._authenticationMessage = response.data;

            // store the refresh token.  We do not want to use the new refresh token returned after refreshing
            // the access token; otherwise, it will never expire.
            this._accessToken = this._authenticationMessage.access_token;
            this._refreshToken = this._authenticationMessage.refresh_token;

            const key: string = this._getTokenStorageKey(this._loginName as string, this._customerID);
            if (this._loginAutomatically) {
                storageService.local.set(key, this._authenticationMessage);
            } else {
                storageService.session.set(key, this._authenticationMessage);
            }

            const user = this._getUserModel(this._authenticationMessage);

            return user;
            //return new RestResponse<IeLynxUserModel>(new RestStatus(data.status.code, data.status.text), user);
        }
    }

    public async authenticateSSO(customerID: number | null,
        accessToken: string,
        screenHeight?: number,
        screenWidth?: number,
        isMobile?: boolean,
        loginAutomatically?: boolean,
        bypassSsoTenantCheck?: boolean): Promise<IAuthenticationResult> {

        this._loginAutomatically = (typeof (loginAutomatically) === "boolean") ? loginAutomatically : false;

        const data = await this._callTokenEndpoint(
            "password",
            [
                "customerid=" + customerID,
                "authenticationType=OpenIDConnect",
                "accessToken=" + accessToken,
                "screenHeight=" + screenHeight,
                "screenWidth=" + screenWidth,
                "isMobile=" + isMobile,
                "bypassSsoTenantCheck=" + bypassSsoTenantCheck
            ]);

        return this._processAuthenticationResponse(data as AxiosResponse<IAuthenticationMessage>);
    }

    public async authenticateIDToken(customerID: number,
        idToken: string,
        screenHeight?: number,
        screenWidth?: number,
        isMobile?: boolean): Promise<IAuthenticationResult> {

        const data = await this._callTokenEndpoint(
            "password",
            [
                "customerid=" + customerID,
                "authenticationType=eLynxIDToken",
                "idToken=" + idToken,
                "screenHeight=" + screenHeight,
                "screenWidth=" + screenWidth,
                "isMobile=" + isMobile
            ]);

        return this._processAuthenticationResponse(data as AxiosResponse<IAuthenticationMessage>);
    }

    public async acquireToken(): Promise<string> {

        let accessToken: string = this._accessToken as string;

        //if the token is going to expire within two minutes, refresh it
        if (this._authenticationMessage && differenceInSeconds(new Date(this._authenticationMessage[".expires"]), new Date()) <= 120) {
        //if (this._authenticationMessage && moment(this._authenticationMessage[".expires"]).diff(moment(), "seconds") <= 120) {

            //try {
                //@@kg strict null check in tsconfig
                //Argument of type 'string | null' is not assignable to parameter of type 'string'.
                //Type 'null' is not assignable to type 'string'.ts(2345)
                accessToken = await this._refreshAccessToken(this._refreshToken as string);
            //} catch (err) {
            //    //@@kg is this needed? just let go?
            //    throw new Error("Could not refresh token");
            //}
        }

        return accessToken;
    }

    public getAuthMessageFromStorage(loginName: string, customerID: number): IAuthenticationMessage | null {

        if (customerID && loginName.length > 1) {
            const key = this._getTokenStorageKey(loginName, customerID);
            return this._loginAutomatically ?
                storageService.local.get<IAuthenticationMessage | null>(key, null) :
                storageService.session.get<IAuthenticationMessage | null>(key, null);
        }

        return null;
    }

    public getUser(): IeLynxUser | undefined {
        return this._authenticationMessage ? this._getUserModel(this._authenticationMessage) : undefined;
    }

    public logout(): void {

        // if (this._refreshTimerID > -1) {
        //     clearInterval(this._refreshTimerID);
        //     this._refreshTimerID = -1;
        // }

        this._authenticationMessage = null;
        this._accessToken = null;
        this._refreshToken = null;

        this._loginAutomatically = false;

        //ensure that there is no token left for the current user/customer in either session or local storage
        if (this._loginName) {
            const key: string = this._getTokenStorageKey(this._loginName, this._customerID);

            storageService.local.remove(key);
            storageService.session.remove(key);
        }

        //get rid of some existing session items
        storageService.session.remove([StorageKeys.AppSettings, StorageKeys.UserSettings, StorageKeys.ImpersonatingGlobalLoginID, StorageKeys.ImpersonatorUserID, StorageKeys.ImpersonatorUserLogin]);
        storageService.local.remove([StorageKeys.AppSettings, StorageKeys.UserSettings]);

        

        //this._storageService.session.removeItem(AppStorageKey.AppState);
        //this._storageService.session.removeItem(AppStorageKey.UserSettings);
        //this._storageService.session.removeItem(AppStorageKey.NavigationGroups);
        //this._storageService.session.removeItem(AppStorageKey.GroupsFlatList);
    }

}

const eLynxAuthService = new ELynxAuthService();
export default eLynxAuthService;
